module.exports = __webpack_public_path__ + "static/absolutecard-49814533427a3b6c92829856e7c20223.png";